const LOCAL_STORAGE_KEY = 'dev.override.remoteEntries';
export const getOverrideRemoteEntries = () => {
    try {
        const overrides = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (!overrides) {
            return null;
        }
        return JSON.parse(overrides);
    }
    catch {
        // noop
    }
    return null;
};
export const setOverrideRemoteEntries = (overrides) => {
    try {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(overrides));
    }
    catch {
        // noop
    }
};
export const resetOverrideRemoteEntries = () => {
    try {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
    catch {
        // noop
    }
};
